import React, { useState, useEffect } from "react";
import View from 'src/components/view';
import Element from 'src/components/element';
import utils from "src/components/utils";


const SolicitarLojaConsultor = function () {
  let [view, setView] = useState({});

  useEffect(() => {

  });


  return (
    <View view={view} name="solicitar-loja-consultor">
      <div align="center" style={{background: '#fff',fontSize: '30px',padding:'40px',border:'1px solid #dedede'}}> 
         Quero minha Loja!
      </div>
    </View>
  );
}

export default SolicitarLojaConsultor;